// @ts-nocheck
import { SalesOrderItem, ChildBundle, BundleItem } from "../../../types";
const pairSalesOrderBundlesFromApi = (bundles: SalesOrderItem[]) => {
	const primaryItems = bundles.filter(
		(bundle) =>
			bundle.bundleItem?.bundleItemGroup &&
			bundle.bundleItem.bundleItemGroup.slug === "primary" &&
			bundle?.bundle === null
	);

	// primary items that ARE from a child bundle
	const childBundlePrimaryItems = bundles.filter(
		(bundle) => bundle?.bundle !== null
	);

	// find child bundle items by parentSalesOrderItem
	const childBundleItems: BundleItem[] = childBundlePrimaryItems.map(
		(childBundlePrimaryItem) => {
			let childBundleMatches = bundles.filter((bundle) => {
				return (
					typeof bundle?.parentSalesOrderItem === "object" &&
					bundle?.parentSalesOrderItem?.uuid ==
						childBundlePrimaryItem?.uuid
				);
			});
			return {
				bundle: childBundlePrimaryItem.bundle!,
				parentSalesOrderItem:
					childBundlePrimaryItem.parentSalesOrderItem,
				bundleItems: [childBundlePrimaryItem, ...childBundleMatches],
			};
		}
	);

	const totalBundle = primaryItems.map((bundleItem) => {
		// find bundle items of the parent bundle by parentSalesOrderItem
		let bundleItemMatches = bundles.filter((bundle) => {
			return (
				typeof bundle?.parentSalesOrderItem === "object" &&
				bundle?.parentSalesOrderItem?.uuid == bundleItem?.uuid &&
				bundle.bundle === null
			);
		});

		// find child bundles of the parent bundle by parentSalesOrderItem
		let childBundleMatches = childBundleItems.filter((bundle) => {
			return (
				typeof bundle?.parentSalesOrderItem === "object" &&
				bundle.parentSalesOrderItem?.uuid == bundleItem?.uuid
			);
		});

		if (childBundleMatches.length > 0) {
			childBundleMatches.forEach((childBundleMatch) => {
				const primaryChildBundleItems =
					childBundleMatch?.bundleItems?.find((childBundleItem) => {
						return childBundleItem?.bundle !== null;
					})?.bundle.bundleItems;

				const formattedChildBundleItems =
					childBundleMatch?.bundleItems?.map((childBundleItem) => {
						const originalBundleItem =
							primaryChildBundleItems?.find(
								(item: BundleItem) => {
									return (
										item?.item?.uuid ===
										childBundleItem?.item?.uuid
									);
								}
							);

						return {
							...childBundleItem,
							originalBundleItemGroup:
								originalBundleItem?.bundleItemGroup,
						};
					});

				childBundleMatch.bundleItems = formattedChildBundleItems;
			});
		}
		// return bundle items AND child bundles for the parent bundle
		return {
			bundleItems: [bundleItem, ...bundleItemMatches],
			...(childBundleMatches.length > 0 && {
				childBundle: childBundleMatches,
			}),
			quantity: bundleItem.quantity,
			bundle: {
				...bundleItem.bundleItem.bundle,
			},
		};
	});

	return totalBundle;
};

export default pairSalesOrderBundlesFromApi;
